// src/modules/moduleRegistry.ts
export type ModuleCode =
  | 'USER'
  | 'HR'
  | 'INV'
  | 'FIN'
  | 'AP'
  | 'CASH'
  | 'AR'
  | 'ASSETS'
  | 'NTX'
  | 'SU'
  | 'FLEET'
  | 'INT'
  | 'POS'
  | 'SAL'
  | 'PUR'
  | 'RPT'
  | 'NTF'
  | 'PAYROLL'
  | 'RAQ'
  | 'AME'
  | 'MRP'
  | 'PROJECT';

// ✅ بادئة واحدة لكل موديول (طابقها مع الراوتر عندك)
export const MODULE_PREFIX: Record<ModuleCode, string> = {
  INV: '/INV',
  HR: '/HR',
  FIN: '/FINANCE',   // إن كانت عندك /FIN بدل /FINANCE غيّرها هنا
  CASH: '/CASH',
  AP: '/AP',
  AR: '/AR',
  ASSETS: '/ASSETS',
  NTX: '/NTX',
  SU: '/SU',
  FLEET: '/FLEET',
  INT: '/INT',
  POS: '/POS',
  SAL: '/SAL',
  PUR: '/PUR',
  RPT: '/RPT',
  NTF: '/NTF',
  PAYROLL: '/PAY',   // إن كانت /PAYROLL غيّرها هنا
  RAQ: '/RAQ',
  AME: '/AME',
  MRP: '/MRP',
  PROJECT: '/PROJECT',
  USER: '/UserDashboard'
};

// استنتاج الموديول من المسار
export function detectModuleFromPath(pathname: string): ModuleCode | null {
  // debugger
  const p = pathname.toLowerCase();
  const entries = Object.entries(MODULE_PREFIX) as [ModuleCode, string][];
  entries.sort((a, b) => b[1].length - a[1].length); // أطول أولًا
  for (const [code, base] of entries) {
    const pre = base.toLowerCase();
    if (p === pre || p.startsWith(pre + '/')) return code;
  }
  return null;
}

// قاعدة التوجيه عند تبديل الموديول يدويًا
// export const MODULE_BASE: Record<ModuleCode, string> = MODULE_PREFIX;

export const MODULE_BASE: Record<ModuleCode, string> = {
  INV: '/INV/HomePage',       // ← لو عندك داشبورد للمخزون
  HR: '/HR/HomePage',         // ← انتبه لحالة الأحرف حسب الراوتر عندك
  FIN: '/FINANCE/HomePage',             // ← إن كانت المالية تهبط على الجذر
   CASH: '/CASH/HomePage',
  AP: '/AP/HomePage',
  AR: '/AR/HomePage',
  ASSETS: '/ASSETS/HomePage',
  NTX: '/NTX/HomePage',
  SU: '/SU/HomePage',
  FLEET: '/FLEET/HomePage',
  INT: '/INT/HomePage',
  POS: '/POS/HomePage',
  SAL: '/SAL/HomePage',
  PUR: '/PUR/HomePage',
  RPT: '/RPT/HomePage',
  NTF: '/NTF/HomePage',
  PAYROLL: '/PAY/HomePage',             // أو '/PAY/Dashboard' إذا موجود
  RAQ: '/RAQ/HomePage',
  AME: '/AME/HomePage',
  MRP: '/MRP/HomePage',
  PROJECT: '/PROJECT/HomePage',
  USER: '/UserDashboard'
};